/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import Calendar from './calendar/kn_IN';
import DatePicker from './date-picker/kn_IN';
import Pagination from './pagination/kn_IN';
import TimePicker from './time-picker/kn_IN';

export default {
  locale: 'kn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  // locales for all comoponents
  global: {
    placeholder: 'à²¦à²¯à²µà²¿à²à³à²à³ à²à²°à²¿à²¸à²¿'
  },
  Table: {
    filterTitle: 'à²ªà²à³à²à²¿ à²¸à³à²¸à²¿',
    filterConfirm: 'à²¸à²°à²¿',
    filterReset: 'à²®à²°à³à²¹à³à²à²¦à²¿à²¸à²¿',
    emptyText: 'à²®à²¾à²¹à²¿à²¤à²¿ à²à²²à³à²²',
    selectAll: 'à²ªà³à²°à²¸à³à²¤à³à²¤ à²ªà³à²à²µà²¨à³à²¨à³ à²à²¯à³à²à³à²®à²¾à²¡à²¿',
    selectInvert: 'à²ªà³à²°à²¸à³à²¤à³à²¤ à²ªà³à²à²µà²¨à³à²¨à³ à²¤à²¿à²°à³à²à²¿à²¸à²¿',
    sortTitle: 'à²µà²¿à²à²à²¡à²¿à²¸à²¿'
  },
  Modal: {
    okText: 'à²¸à²°à²¿',
    cancelText: 'à²°à²¦à³à²¦à³',
    justOkText: 'à²¸à²°à²¿'
  },
  Popconfirm: {
    okText: 'à²¸à²°à²¿',
    cancelText: 'à²°à²¦à³à²¦à³'
  },
  Transfer: {
    titles: ['', ''],
    notFoundContent: 'à²¦à³à³à²°à³à²¤à²¿à²²à³à²²',
    searchPlaceholder: 'à²à²²à³à²²à²¿ à²¹à³à²¡à³à²à²¿',
    itemUnit: 'à²µà²¿à²·à²¯',
    itemsUnit: 'à²µà²¿à²·à²¯à²à²³à³'
  },
  Select: {
    notFoundContent: 'à²¦à³à³à²°à³à²¤à²¿à²²à³à²²'
  },
  Upload: {
    uploading: 'à²à²°à²¿à²¸à²¿...',
    removeFile: 'à²«à³à²²à³ à²¤à³à²à³à²¦à³à²¹à²¾à²à²¿',
    uploadError: 'à²à²°à²¿à²¸à³à²µ à²¦à³à²·',
    previewFile: 'à²«à³à²²à³ à²®à³à²¨à³à²¨à³à²'
  }
};
